function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2617",
  "data-name": "Group 2617",
  transform: "translate(-222.504 -611.086)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2600",
  "data-name": "Group 2600"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2598",
  "data-name": "Group 2598",
  transform: "translate(-73.723 419.483)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2596",
  "data-name": "Group 2596",
  transform: "translate(297.722 193.517)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3741",
  "data-name": "Path 3741",
  d: "M328.87,251.281a12.118,12.118,0,0,1-5.2,1.557,11.643,11.643,0,0,1-5.2-1.554l.908-1.208a2.836,2.836,0,0,1,1.421-1.032,2.478,2.478,0,0,1,.573-.1c1.141-.091,1.4.358,2.327.372s1.182-.442,2.324-.331a2.53,2.53,0,0,1,.712.165,2.867,2.867,0,0,1,1.215.935Z",
  transform: "translate(-301.141 -202.65)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3742",
  "data-name": "Path 3742",
  d: "M327.018,240.986c-.079.34-.334.414-1.327,1.1a3.635,3.635,0,0,1-3.726,0c-.992-.69-1.247-.764-1.326-1.1",
  transform: "translate(-301.499 -201.341)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2594",
  "data-name": "Group 2594",
  transform: "translate(5.409 27.054)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3743",
  "data-name": "Path 3743",
  d: "M304.2,226.438a2.528,2.528,0,0,1,3.113.017,6.054,6.054,0,0,0,2.592,1.325,6.321,6.321,0,0,0,2.04.108,14.942,14.942,0,0,0,2.686-.645c.634-.178,1.166-.33,1.553-.442",
  transform: "translate(-304.198 -225.91)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2595",
  "data-name": "Group 2595",
  transform: "translate(27.125 27.054)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3745",
  "data-name": "Path 3745",
  d: "M340.691,225.911a2.569,2.569,0,0,0-1.619.544,6.059,6.059,0,0,1-2.592,1.325,6.327,6.327,0,0,1-2.041.108,14.959,14.959,0,0,1-2.686-.645c-.633-.178-1.165-.33-1.553-.442",
  transform: "translate(-330.201 -225.91)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_3746",
  "data-name": "Path 3746",
  d: "M297.765,222.728c0-5.249-.1-6,0-11.642.567-1.638,7.043-5.57,12.385-9.6a31.12,31.12,0,0,1,6.412-3.717",
  transform: "translate(-297.722 -194.218)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3747",
  "data-name": "Path 3747",
  d: "M346.019,225.394c0-5.093.167-9.735,0-15.077-.3-.713-13.929-12.98-24.745-16.8",
  transform: "translate(-301.604 -193.517)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3748",
  "data-name": "Path 3748",
  d: "M316.462,219.1A6.6,6.6,0,0,0,312.514,217a21.638,21.638,0,0,0-6.185,0",
  transform: "translate(-299.141 -197.349)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3749",
  "data-name": "Path 3749",
  d: "M328.547,219.069a6.6,6.6,0,0,1,3.948-2.105,21.605,21.605,0,0,1,6.185,0",
  transform: "translate(-302.803 -197.343)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3750",
  "data-name": "Path 3750",
  d: "M330.1,256.935c-3.292,2.952-6.855,4.645-10.131,4.645-7.841,0-22.2-15.189-22.2-33.926",
  transform: "translate(-297.731 -199.144)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_182",
  "data-name": "Ellipse 182",
  cx: 17.088,
  cy: 17.088,
  r: 17.088,
  transform: "translate(330.548 231.074)",
  strokeWidth: 3,
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3755",
  "data-name": "Path 3755",
  d: "M89.352,107.169h32.99",
  transform: "translate(241.668 139.035)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2615",
  "data-name": "Group 2615",
  transform: "translate(338.412 251.145)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_160",
  "data-name": "Ellipse 160",
  cx: 0.454,
  cy: 0.454,
  r: 0.454,
  transform: "translate(7.621 2.54)",
  strokeWidth: 3,
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  fill: "none"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_161",
  "data-name": "Ellipse 161",
  cx: 0.635,
  cy: 0.635,
  r: 0.635,
  transform: "translate(12.704 6.896)",
  strokeWidth: 3,
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  fill: "none"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_162",
  "data-name": "Ellipse 162",
  cx: 1.542,
  cy: 1.542,
  r: 1.542,
  transform: "translate(15.879 1.18)",
  strokeWidth: 3,
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  fill: "none"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_164",
  "data-name": "Ellipse 164",
  cx: 1.634,
  cy: 1.634,
  r: 1.634,
  strokeWidth: 3,
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3757",
  "data-name": "Path 3757",
  d: "M0-11.619S-.371-8.877,3.607-9.174",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3758",
  "data-name": "Path 3758",
  d: "M0-11.619S-.371-8.877,3.607-9.174",
  transform: "translate(8)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3759",
  "data-name": "Path 3759",
  d: "M0-11.619S-.371-8.877,3.607-9.174",
  transform: "translate(15)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeWidth: 3
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2599",
  "data-name": "Group 2599",
  transform: "translate(228.889 665.562)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2565",
  "data-name": "Group 2565",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3640",
  "data-name": "Path 3640",
  d: "M96.415,99.586s.885,9.615-.4,12.489a13.2,13.2,0,0,1-3.612,4.811",
  transform: "translate(-92.703 -98.909)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
}))));

var SvgDrynessIcon = function SvgDrynessIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69.996,
    height: 75.146,
    viewBox: "0 0 69.996 75.146",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDrynessIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dryness-icon.38fc6a64.svg";
export { ForwardRef as ReactComponent };